import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import OtpInput from 'react-otp-input';
import { useTheme } from '@emotion/react';
import { api } from 'src/Api';

// ----------------------------------------------------------------------//

export default function OtpForm() {
  const location = useLocation();

  const { user, token, message, from } = location.state || {};

  const theme = useTheme();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [alert, setalert] = useState({ visible: false, message: '', color: 'success' });
  const [loading, setloading] = useState(false);
  const [resendotp, setresendotp] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const otpInputStyle = {
    width: '100%',
    height: '56px',
    textAlign: 'center',
    fontSize: '18px',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '6px',
    border: `1px solid ${theme.palette.primary.main} !important`
  };

  const otpContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  };

  // const codeCheck = localStorage.getItem('code');

  function VerifyCode() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        email: localStorage.getItem('email'),
        otp: otp
      }),
      redirect: 'follow'
    };
    setloading(true);

    fetch(from === 'forgetPassword' ? api.verify_forgot_password : api.otp_verify, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          if (from === 'forgetPassword') {
            navigate('/changePassword', { replace: true, state: { email: user?.email } });
          } else {
            setalert({ visible: true, message: result.message });
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            setTimeout(() => {
              navigate('/dashboard/app', { replace: true });
            }, 2000);
          }
          setloading(false);
        } else {
          setloading(false);
          setalert({ visible: true, message: result.error, color: 'error' });
        }
      })
      .catch((error) => {
        setloading(false);
        setalert({ visible: true, message: 'An error occurred.', color: 'error' });
      });
  }

  const ResendOTP = () => {
    setresendotp(true);
    var formdata = new FormData();
    formdata.append('email', localStorage.getItem('email'));
    from === 'forgetPassword' && formdata.append('type', 'forgot_password');
    from === 'register' && formdata.append('type', 'register');
    from === 'change_email' && formdata.append('type', 'change_email');
    from === 'account_delete' && formdata.append('type', 'account_delete');

    var requestOptions = {
      method: 'POST',
      body: formdata
    };

    fetch(api.resend_otp, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setloading(false);
          handleResend();
        } else {
          setalert({ visible: true, message: result.error, color: 'error' });
        }
      })
      .catch((error) => {
        setalert({ visible: true, message: 'An error occurred.', color: 'error' });
      })
      .finally(() => {
        setresendotp(false);
      });
  };

  const handleCode = () => {
    setloading(true);

    if (seconds == 0) {
      // showToastError('OTP has been expired. Please request a new one.');
      setalert({
        visible: true,
        message: 'OTP has been expired. Please request a new one',
        color: 'error'
      });
      setloading(false);
    } else {
      VerifyCode();
    }
  };

  const handleResend = () => {
    setMinutes(0);
    setSeconds(60);
  };

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : `${time}`;
  };

  return (
    <Stack spacing={2}>
      {alert.visible && (
        <Alert
          onClose={() => {
            setalert({ visible: false, message: '', color: 'success' });
          }}
          severity={alert?.color}
        >
          {alert.message}
        </Alert>
      )}
      <div style={otpContainerStyle}>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
          renderInput={(props) => <input {...props} style={otpInputStyle} />}
        />
      </div>

      <LoadingButton
        onClick={() => {
          if (seconds == 0) {
            ResendOTP();
          }
        }}
        disabled={seconds == 0 ? false : true}
        fullWidth
        size="large"
        variant="contained"
        loading={resendotp}
      >
        {seconds > 0 ? `\t ${formatTime(minutes)}:${formatTime(seconds)}` : <>Resend OTP</>}
      </LoadingButton>

      <LoadingButton
        onClick={handleCode}
        fullWidth
        size="large"
        variant="contained"
        loading={loading}
      >
        Continue
      </LoadingButton>

      <LoadingButton
        style={{ marginTop: 10 }}
        fullWidth
        size="large"
        type="submit"
        variant="outlined"
        onClick={() => {
          navigate('/login');
        }}
      >
        Back to Login
      </LoadingButton>
    </Stack>
  );
}
